module.exports = ".SideNavOpen{\r\n    margin-left: 250px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/header/header.component.css
// module id = 970
// module chunks = 1